// opervex-frontend/src/Opervex/Tax/Inbound/NFe.js

class SalesOrder {
  #_api;

  constructor(api) {
    this.#_api = api;
  }

  async convertXML(file) {
    const formData = new FormData();
    formData.append("xmlFile", file);

    return this.#_api.post("/Tax/Inbound/NFe/ConvertXML", formData);
  }
}

export default SalesOrder;
